import { haversineDistance } from './location.js';

var RADIUS_MILES = 500;

function getOrCreateNoResultsEl() {
  var el = document.querySelector('.js-near-me-no-results');
  if (!el) {
    el = document.createElement('p');
    el.className = 'js-near-me-no-results near-me-no-results';
    el.textContent = 'No Mowgli restaurants found within ' + RADIUS_MILES + ' miles of your location.';
    el.hidden = true;
    var grid = document.querySelector('.restaurants-grid');
    if (grid) {
      grid.parentNode.insertBefore(el, grid);
    }
  }
  return el;
}

function setActiveState(active) {
  var btn = document.querySelector('.js-near-me-btn');
  var clearBtn = document.querySelector('.js-near-me-clear');
  if (btn) {
    btn.classList.toggle('near-me-btn--active', active);
  }
  if (clearBtn) {
    clearBtn.hidden = !active;
  }
}

function filterCards(userLat, userLng) {
  var cards = document.querySelectorAll('.restaurant-card');
  var anyVisible = false;

  cards.forEach(function (card) {
    var lat = parseFloat(card.dataset.lat);
    var lng = parseFloat(card.dataset.lng);

    if (isNaN(lat) || isNaN(lng)) {
      card.hidden = true;
      return;
    }

    var dist = haversineDistance(userLat, userLng, lat, lng);
    var within = dist <= RADIUS_MILES;
    card.hidden = !within;
    if (within) {
      anyVisible = true;
    }
  });

  getOrCreateNoResultsEl().hidden = anyVisible;
  setActiveState(true);
}

function clearFilter() {
  document.querySelectorAll('.restaurant-card').forEach(function (card) {
    card.hidden = false;
  });

  var noResults = document.querySelector('.js-near-me-no-results');
  if (noResults) {
    noResults.hidden = true;
  }

  setActiveState(false);
}

function showError() {
  var errEl = document.querySelector('.js-near-me-error');
  if (errEl) {
    errEl.hidden = false;
  }

  var btn = document.querySelector('.js-near-me-btn');
  if (btn) {
    btn.disabled = false;
    btn.textContent = btn.dataset.label || 'Near Me';
  }
}

function init() {
  var btn = document.querySelector('.js-near-me-btn');
  var clearBtn = document.querySelector('.js-near-me-clear');

  if (!btn) {
    return;
  }

  if (!('geolocation' in navigator)) {
    btn.disabled = true;
    btn.title = 'Geolocation is not supported by your browser.';
    return;
  }

  btn.addEventListener('click', function () {
    if (btn.classList.contains('near-me-btn--active')) {
      clearFilter();
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Locating...';

    var errEl = document.querySelector('.js-near-me-error');
    if (errEl) {
      errEl.hidden = true;
    }

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        filterCards(pos.coords.latitude, pos.coords.longitude);
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Near Me';
      },
      function () {
        showError();
      },
      { timeout: 10000 }
    );
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', clearFilter);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
